export default __webpack_public_path__ + "c3c274b8d10a879676b2843ce4feda9e.svg";